import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const SECTIONS = [
  {
    title: "1. Titolare del trattamento",
    body: `Il titolare del trattamento dei dati personali è Personal & Team Coach (di seguito "il Titolare"), raggiungibile all'indirizzo email info@giocalatuapartitamigliore.it. Il Titolare tratta i dati nel rispetto del Regolamento (UE) 2016/679 ("GDPR") e del D.Lgs. 196/2003 come modificato dal D.Lgs. 101/2018.`,
  },
  {
    title: "2. Dati raccolti",
    body: `Attraverso i moduli del sito (prenotazione appuntamenti, prima sessione gratuita, contatti) raccogliamo: nome e cognome, indirizzo email, numero di telefono, sport praticato, età dell'atleta, note e messaggi liberamente inseriti dall'utente, data e fascia oraria richieste. Tramite la sezione Safeguarding raccogliamo segnalazioni anonime in materia di tutela dei minori: in quel caso NON raccogliamo alcun dato del segnalante, ma solo le informazioni volontariamente indicate nel modulo (società sportiva, eventuali nome/cognome/età del soggetto leso e testo della segnalazione). Non raccogliamo categorie particolari di dati (es. dati sanitari) tramite il sito: ti chiediamo di non inserirle nei campi liberi.`,
  },
  {
    title: "3. Finalità e base giuridica",
    body: `I dati sono trattati per: (a) gestire le richieste di appuntamento e di prima sessione gratuita e ricontattarti (base giuridica: esecuzione di misure precontrattuali, art. 6.1.b GDPR); (b) rispondere ai messaggi inviati tramite il modulo contatti (base giuridica: legittimo interesse, art. 6.1.f GDPR); (c) adempiere ad eventuali obblighi di legge (art. 6.1.c GDPR). Il conferimento è facoltativo ma necessario per poter gestire la richiesta.`,
  },
  {
    title: "4. Dati di atleti minorenni",
    body: `Il sito è rivolto anche ad atleti minorenni. I moduli che riguardano un atleta minore di 14 anni devono essere compilati esclusivamente da un genitore o da chi esercita la responsabilità genitoriale, che con l'invio del modulo dichiara di avere tale titolo e presta il consenso al trattamento dei dati del minore per le finalità indicate. Per i minori tra i 14 e i 18 anni raccomandiamo comunque il coinvolgimento di un genitore. Il Titolare non effettua profilazione automatizzata sui dati dei minori.`,
  },
  {
    title: "5. Modalità del trattamento e conservazione",
    body: `I dati sono trattati con strumenti informatici, con misure tecniche e organizzative adeguate a garantirne sicurezza e riservatezza (accesso protetto, credenziali cifrate). Le richieste di contatto e prenotazione sono conservate per un massimo di 12 mesi dall'ultimo contatto, salvo instaurazione di un rapporto professionale (nel qual caso si applicano i termini di legge) o tua richiesta di cancellazione anticipata.`,
  },
  {
    title: "6. Destinatari e fornitori",
    body: `I dati sono accessibili al Titolare e trattati tramite fornitori tecnici che operano come responsabili del trattamento: il provider di hosting della piattaforma e il servizio di invio email transazionale utilizzato per conferme e notifiche. I dati non sono venduti, né comunicati a terzi per finalità di marketing, né trasferiti al di fuori dello spazio previsto dai fornitori nel rispetto del GDPR.`,
  },
  {
    title: "7. Cookie",
    body: `Il sito utilizza esclusivamente cookie tecnici necessari al funzionamento (ad esempio il cookie di sessione dell'area riservata del coach). Non vengono utilizzati cookie di profilazione o di terze parti a fini pubblicitari; per questi cookie tecnici non è richiesto il consenso.`,
  },
  {
    title: "8. I tuoi diritti",
    body: `Ai sensi degli artt. 15-22 GDPR puoi chiedere in qualsiasi momento: accesso ai tuoi dati, rettifica, cancellazione ("diritto all'oblio"), limitazione o opposizione al trattamento, portabilità dei dati. Per i dati di un minore, i diritti sono esercitati da chi esercita la responsabilità genitoriale. Puoi inoltre proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).`,
  },
  {
    title: "9. Come esercitare i diritti",
    body: `Per qualsiasi richiesta relativa alla privacy scrivi a info@giocalatuapartitamigliore.it indicando nell'oggetto "Richiesta privacy". Risponderemo entro 30 giorni.`,
  },
  {
    title: "10. Modifiche a questa informativa",
    body: `Il Titolare può aggiornare la presente informativa; la versione vigente è quella pubblicata su questa pagina. Ultimo aggiornamento: settembre 2026.`,
  },
];

export default function Privacy() {
  return (
    <div className="bg-[#08090C] min-h-screen text-slate-100">
      <header className="backdrop-blur-xl bg-[#08090C]/80 border-b border-white/10 sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="privacy-logo" className="flex items-center gap-2">
            <img src="/logo.png" alt="Personal and Team Coach" className="h-10 w-10 rounded-lg object-cover ring-1 ring-white/10" />
          </Link>
          <Link to="/" data-testid="privacy-back-link"
            className="flex items-center gap-1.5 text-sm text-slate-400 hover:text-sky-400 transition-colors">
            <ArrowLeft className="w-4 h-4" /> Torna al sito
          </Link>
        </div>
      </header>
      <main data-testid="privacy-page" className="max-w-4xl mx-auto px-4 sm:px-6 py-16">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-orange-400">Documento legale</span>
        <h1 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-white font-heading">
          Privacy Policy — Informativa GDPR
        </h1>
        <p className="mt-4 text-slate-400 text-sm">
          Informativa sul trattamento dei dati personali ai sensi dell'art. 13 del Regolamento (UE) 2016/679.
        </p>
        <div className="mt-10 space-y-6">
          {SECTIONS.map((s) => (
            <section key={s.title} className="bg-[#10141D] border border-[#222A3B] rounded-2xl p-6">
              <h2 className="text-lg font-semibold text-white font-heading">{s.title}</h2>
              <p className="mt-3 text-sm text-slate-300 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
      </main>
      <footer className="border-t border-white/10 py-8">
        <p className="text-center text-xs text-slate-600">© 2026 Personal &amp; Team Coach — Mental Coaching Sportivo. Tutti i diritti riservati.</p>
      </footer>
    </div>
  );
}
